<script setup lang="ts">
  const props = defineProps<{
    startDate: string
    endDate: string
    startDateSemantic?: string
    endDateSemantic?: string
  }>()

  const { t } = useI18n()

  const dateRangeA11yLabel = computed(() =>
    t('a11y.dateRange', {
      startDate: props.startDateSemantic || props.startDate,
      endDate: props.endDateSemantic || props.endDate
    })
  )
</script>

<template>
  <div>
    <p class="sr-only">{{ dateRangeA11yLabel }}</p>
    <p class="mb-0 text-body-1">{{ startDate }} <span>–</span></p>
    <p class="mb-0 text-body-1 sm:ml-1 md:ml-0">
      {{ endDate }}
    </p>
  </div>
</template>
